// extracted by mini-css-extract-plugin
export default {"container":"container_gzAU4","item":"item_WyBvE","title":"title_E7TuG","description":"description_xnh1c","hasDeals":"hasDeals_ZUQEK"};